export default __webpack_public_path__ + "images/mc-a2634c60fa92f9ff20f08026a6a4b56e.svg";